import { PersonaRequestBody } from './PersonaRequestBody';
import { AnimationModel } from '../../../models/AnimationModel';

/**
 * @public
 */
export interface PlayAnimationRequestBody extends PersonaRequestBody {
  animation: AnimationModel;
}
